import { useMemo } from 'react'

import { useQuery } from 'react-query'

import { CreditCardAccount } from '@webapp/modules/accounts-payable/entities/CreditCardAccount'
import { creditCardAccountQueries } from '@webapp/modules/accounts-payable/query-configs/creditCardAccountQueries'

interface IUseQueryCreditCardAccountParams {
  accountId: number
  onError?: (err: unknown) => void
}

interface IUseQueryCreditCardAccountReturn {
  account: Nullable<CreditCardAccount>
  isLoading: boolean
  error: unknown
}

export const useQueryCreditCardAccount = ({
  accountId,
  onError,
}: IUseQueryCreditCardAccountParams): IUseQueryCreditCardAccountReturn => {
  const { data, isLoading, error } = useQuery({
    ...creditCardAccountQueries.detail(accountId),
    onError,
  })

  const account = useMemo(
    () => (data ? new CreditCardAccount(data) : null),
    [data]
  )

  return {
    account,
    isLoading,
    error,
  }
}
